import React from "react";
import { Formik } from "formik";
import { Fragment } from "react";
import {
  Typography,
  Grid,
  Button,
  Box,
  Dialog,
  DialogContent,
} from "@mui/material";

import { useAxios } from "../../hooks";
import { TextField } from "../../components";
import { styled } from "@mui/material/styles";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    background: "rgb(255, 255, 255)",
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
  },
}));

const ContentBox = styled(Box)({
  padding: "25px",
  textAlign: "center",
  alignContent: "center",
  alignItems: "center",

  border: "0.6px solid #0000001A",
  borderRadius: "16px",
  backgroundColor: "#ffd0d0",
  backgroundImage:
    "linear-gradient(164deg, rgb(232, 232, 255) 25%, rgb(255, 255, 255) 55%)",
});

const AddParkingVechiclePop = ({
  addParkingDetialPop,
  setAddOpenParkingPop,
  ID,
  setUserData,
}) => {
  const axios = useAxios();

  return (
    <Fragment>
      <StyledDialog
        open={addParkingDetialPop}
        onClose={() => setAddOpenParkingPop(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogContent style={{ padding: "0px" }}>
          <ContentBox>
            <Formik
              initialValues={{ vehicle_number: "" }}
              enableReinitialize
              onSubmit={(formData, { resetForm }) => {
                axios({
                  url: "/admin/parking/add-visitor-parking?visitor_id=" + ID,
                  method: "POST",
                  data: {
                    vehicle_numbers: [formData.vehicle_number],
                  },
                  disableRedirect: true,
                }).then((response) => {
                  if (response.status) {
                    axios({
                      url: "admin/profile/get-visitor-detail?visitor_id=" + ID,
                      disableRedirect: true,
                    }).then((response) => {
                      if (response.status) {
                        setUserData(response.data);
                      }
                      setAddOpenParkingPop(false);
                    });
                  }
                  resetForm();
                });
              }}
            >
              {(formikProps) => {
                return (
                  <Fragment>
                    <Grid item xs={12}>
                      <Typography
                        variant="body1"
                        fontSize={"14px"}
                        fontWeight={"900"}
                        color={"#00000080"}
                        mb={3}
                      >
                        Add Parking Vehicle
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        name={`vehicle_number`}
                        placeholder={"Vehicle No"}
                        formikProps={formikProps}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        fullWidth
                        m={"2px 2px"}
                        style={{ marginTop: "15px" }}
                        onClick={formikProps.handleSubmit}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Fragment>
                );
              }}
            </Formik>
          </ContentBox>
        </DialogContent>
      </StyledDialog>
    </Fragment>
  );
};

export default AddParkingVechiclePop;
